import React from 'react'
import {VerificacionDato} from '../../interfaces/verificacion-datos.interface'

const estilos: {[clave: string]: React.CSSProperties} = {
  caja: {
    border: '1px solid #e67e22',
    borderLeft: '4px solid #e67e22',
    borderRadius: 8,
    padding: '12px 16px',
    background: 'rgba(230, 126, 34, 0.08)',
  },
  titulo: {fontWeight: 600, marginBottom: 4},
  introduccion: {marginBottom: 8},
  motivo: {marginTop: 10},
  motivoTitulo: {fontWeight: 600},
  queRevisar: {marginTop: 4, opacity: 0.75},
}

interface PropsAvisoVerificacionDatos {
  verificaciones: Array<VerificacionDato>
  titulo?: string
  introduccion?: string
}

const AvisoVerificacionDatos = ({
  verificaciones,
  titulo = 'Debe verificar esta información',
  introduccion,
}: PropsAvisoVerificacionDatos) => {
  const pendientes = (verificaciones ?? []).filter((verificacion) => verificacion.pendiente)

  if (pendientes.length === 0) return null

  return (
    <div style={estilos.caja}>
      <p className='m' style={estilos.titulo}>
        {titulo}
      </p>
      {introduccion && (
        <p className='m' style={estilos.introduccion}>
          {introduccion}
        </p>
      )}
      {pendientes.map((verificacion) => (
        <div key={`${verificacion.codigomotivo}-${verificacion.identidad}`} style={estilos.motivo}>
          <p className='m' style={estilos.motivoTitulo}>
            {verificacion.titulo}
          </p>
          <p className='m'>{verificacion.mensaje}</p>
          {verificacion.querevisar && (
            <p className='s' style={estilos.queRevisar}>
              {`Qué revisar: ${verificacion.querevisar}`}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}

export default AvisoVerificacionDatos
